module.exports = __webpack_public_path__ + "media/images/episode2-1fe34ccd5a16610cb23d991550de2d91.jpeg";